
<script>
import PieChart from "../reporting/pieChart.vue";


export default {

  components: { PieChart},

  props: {

    genderRate: {
        type: Object,
        default: () => null
        }
    },

 
};
</script>

<template>

    <div class="card h-100" v-if="genderRate && genderRate.count && genderRate.labels " style="border:1px solid #ddd;">
        <div class="card-body h-100"> 

            <h4 class="text-dark text-uppercase font-weight-bold">{{$t('campaign.card.gender') }}</h4>


         <PieChart :data="genderRate.count" :labels="genderRate.labels"  />
        </div> 
    </div>

</template>